import {Component, EventEmitter, Input, OnInit, Output, SimpleChanges, OnChanges} from '@angular/core';
import {FormGroup, ReactiveFormsModule} from "@angular/forms";
import {CheckBoxModule} from '@syncfusion/ej2-angular-buttons'

@Component({
    selector: 'app-form-checkbox',
    imports: [
        ReactiveFormsModule,
        CheckBoxModule
    ],
    templateUrl: './form-checkbox.component.html',
    styleUrl: './form-checkbox.component.scss'
})
export class FormCheckboxComponent implements OnInit, OnChanges {

  @Input() public fCN: string = '';
  @Input() public labelPosition: 'Before' | 'After' = 'After';
  @Input() public value: string | boolean | number = '';
  @Input() public label: string = '';
  @Input() public checked: boolean = false;
  @Input() public indeterminate: boolean = false;
  @Input() public disabled: boolean = false; // Optional, for disabled state
  @Input() public cssClass: string = '';
  @Input() public fG: FormGroup = new FormGroup({});
  @Input() public showErrorState: boolean = true;
  @Output() public checkedChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  public ngOnInit(): void {
    this.setDisabledState(this.disabled);
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['disabled']) {
      this.setDisabledState(changes['disabled'].currentValue);
    }
  }

  private setDisabledState(disabled: boolean): void {
    const control = this.fG.controls[this.fCN];
    if (!control) return;
    if (disabled) {
      control.disable();
    } else {
      control.enable();
    }
  }

  public hasControl(): boolean {
    return !!this.fCN && !!this.fG?.controls?.[this.fCN];
  }

  public onStandaloneChange(event: {checked?: boolean}): void {
    this.checkedChange.emit(!!event.checked);
  }

}
